import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import type { ProjectWorkers } from 'modules/project_management/hooks/projectWorker/useGetProjectsAssignedToWorker'

export interface IProjects {
  projectsAssigned: ProjectWorkers | undefined
}

class ProjectsStore extends Model<IProjects> {
  constructor(attr: IProjects) {
    super(attr)
    makeObservable(this, {
      projectsAssigned: computed,
    })
  }

  get hasProjectsAssigned(): boolean {
    return this.projectsAssigned ? this.projectsAssigned.length > 0 : false
  }

  get projectsAssigned(): ProjectWorkers | undefined {
    return this.attributes.projectsAssigned
  }

  get projectOptions() {
    return (
      this.attributes.projectsAssigned?.map((project) => ({
        value: project.imputableProject?.id || '',
        label: project.imputableProject?.name || '',
        assigned: project.assigned,
        code: project.imputableProject?.code,
        status: project.imputableProject?.status,
      })) || []
    )
  }

  get projectWorkerIds(): number[] {
    return this.attributes.projectsAssigned?.map((project) => project.id) || []
  }

  projectName = (projectId: string) => {
    return (
      this.attributes.projectsAssigned?.find(
        (project) => project.imputableProject?.id === Number(projectId)
      )?.imputableProject?.name || ''
    )
  }

  project = (projectId: string) => {
    return this.attributes.projectsAssigned?.find(
      (project) => project.imputableProject?.id === Number(projectId)
    )?.imputableProject
  }

  subprojectName = (projectId: string, subprojectId: string) => {
    return (
      this.attributes.projectsAssigned
        ?.find((project) => project.imputableProject?.id === Number(projectId))
        ?.imputableProject?.subprojects?.find(
          (subproject) => subproject.id === Number(subprojectId)
        )?.name || ''
    )
  }

  subprojectOptions(projectId: string) {
    return (
      this.attributes.projectsAssigned
        ?.find((project) => project.imputableProject?.id === Number(projectId))
        ?.imputableProject?.subprojects?.map((subproject) => ({
          value: subproject.id || '',
          label: subproject.name || '',
        })) || []
    )
  }
}

export default ProjectsStore
